// ThemeToggle — cápsula de vidrio neutro en la TopBar que cicla claro→oscuro→sistema.
import { Monitor, Moon, Sun } from "lucide-react";

import { useTheme, type ThemePref } from "@/lib/theme";

const NEXT: Record<ThemePref, ThemePref> = { light: "dark", dark: "system", system: "light" };
const LABEL: Record<ThemePref, string> = { light: "Tema claro", dark: "Tema oscuro", system: "Tema del sistema" };

export function ThemeToggle() {
  const [pref, setPref] = useTheme();
  const Icon = pref === "light" ? Sun : pref === "dark" ? Moon : Monitor;
  return (
    <button
      onClick={() => setPref(NEXT[pref])}
      className="vision-focusable flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/[0.06] text-[var(--color-text-secondary)] transition hover:bg-white/10"
      aria-label={LABEL[pref]}
      title={LABEL[pref]}
    >
      <Icon size={16} />
    </button>
  );
}
